import "core-js/modules/es.array.slice.js";
import { ref, onMounted } from "vue";
import { getHomeCorporateAdvantageList_url } from "@/api"; //引入发送请求获取数据的方法

export default {
  components: {},
  name: "invest",
  setup: function setup() {
    var items = [{
      id: 1,
      text: "Item 1",
      iconImg: require("@/pages/aboutUs/images/about_icon_01.png")
    }, {
      id: 2,
      text: "Item 2",
      iconImg: require("@/pages/aboutUs/images/about_icon_02.png")
    }, {
      id: 3,
      text: "Item 3",
      iconImg: require("@/pages/aboutUs/images/about_icon_03.png")
    }];
    var displayedItems = ref(items.slice(0, 2));
    var showMore = ref(false);
    var showMoreFlag = ref(false); //控制按钮

    var activeNames = ref(-1);

    var toggleMore = function toggleMore() {
      showMore.value = true;
      activeNames.value = 1;
    };

    var jumpWeb = function jumpWeb(url) {
      window.open(url);
    };

    var retract = function retract(name) {
      activeNames.value = -1; // console.log(activeNames.value, '看看是什么')

      showMore.value = false;
    };

    return {
      showMore: showMore,
      showMoreFlag: showMoreFlag,
      toggleMore: toggleMore,
      activeNames: activeNames,
      retract: retract,
      jumpWeb: jumpWeb
    };
  }
};